

export const regexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
//export const regxPhone = /^\d{8,10}$/;

export const regxPhone = /^(\+[0-9]{1,3}\s)?[0-9]{8,12}$/

export const regxLocalPhone = /^(\+65\s)?[0-9]{8}$/

export const localPhoneError='Singapore phone shall be 12345678 or +65 12345678'

export const phoneHelpText='Phone number (e.g. 87654321 Or +1 12345678)'


export const regxCountyCode = /^[1-9][0-9]{0,2}$/
export const regxPhoneNumber = /^[0-9]{8,12}$/